import {Item} from '../../types/packingSlipStatusResponse';

const filterCanceledPackingSlipItems = (item: Item): boolean => {
    return item.qty !== item.qtyCanceled;
};

export default filterCanceledPackingSlipItems;
